export const businessServices = [
  {
    icon: 'calculator-outline',
    title: 'Accounting & Bookkeeping',
    description:
      'Accurate financial records, accounts payable and receivable, and dependable documentation for day-to-day operations.',
    image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1400&q=80',
    category: 'business',
  },
  {
    icon: 'document-text-outline',
    title: 'Tax Planning & Compliance',
    description:
      'Strategic tax planning, filing support, and corporate compliance to minimize risk and maintain regulatory alignment.',
    image: 'https://images.unsplash.com/photo-1554224154-22dec7ec8818?auto=format&fit=crop&w=1400&q=80',
    category: 'business',
  },
  {
    icon: 'trending-up-outline',
    title: 'Business Advisory',
    description:
      'Practical guidance on growth, operations, and decision-making to help leadership teams move with confidence.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=80',
    category: 'business',
  },
  {
    icon: 'bar-chart-outline',
    title: 'Financial Reporting',
    description:
      'Clear statements, performance reports, and insights that give stakeholders a reliable view of business health.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80',
    category: 'business',
  },
  {
    icon: 'people-outline',
    title: 'Payroll & HR Support',
    description:
      'Structured payroll processing and HR administration support to keep teams organized and compliant.',
    image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80',
    category: 'business',
  },
];

export const itServices = [
  {
    icon: 'laptop-outline',
    title: 'IT Consulting',
    description:
      'Technology strategy, infrastructure guidance, and practical recommendations aligned with business priorities.',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1400&q=80',
    category: 'it',
  },
  {
    icon: 'globe-outline',
    title: 'Web Development',
    description:
      'Professional websites and web applications built to strengthen credibility, engagement, and digital presence.',
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1400&q=80',
    category: 'it',
  },
  {
    icon: 'phone-portrait-outline',
    title: 'Mobile App Development',
    description:
      'Native and cross-platform mobile solutions designed for usability, performance, and business impact.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1400&q=80',
    category: 'it',
  },
  {
    icon: 'code-slash-outline',
    title: 'Custom Software Solutions',
    description:
      'Tailored software systems that streamline workflows, reduce manual effort, and support scalable operations.',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1400&q=80',
    category: 'it',
  },
  {
    icon: 'sparkles-outline',
    title: 'Digital Solutions',
    description:
      'Integrated digital tools and automation to improve efficiency, visibility, and customer experience.',
    image: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=1400&q=80',
    category: 'it',
  },
];

export const services = [...businessServices, ...itServices];
